/*  eslint no-param-reassign: ["error", { "props": false }]*/

import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import clone from 'clone';
import {
  Form,
  Grid,
} from 'semantic-ui-react';
import { required } from '@mhub/web-validations';
import AppForm from '../../components/AppForm';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class TagForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    tag: PropTypes.shape({
      name: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultValues = {
    name: '',
    description: '',
  }
  constructor(props) {
    super(props);
    const tag = Object.assign({}, TagForm.defaultValues, props.tag || {});
    this.state = {
      tag,
      oriTag: clone(tag),
      errMessages: [],
    };
    this.validation = {
      name: createRef(),
    };
  }
  componentWillReceiveProps(nextProps) {
    let tag = Object.assign({}, TagForm.defaultValues, this.state.tag);
    let oriTag = this.state.oriTag;
    if (JSON.stringify(this.props.tag) !== JSON.stringify(nextProps.tag)) {
      tag = Object.assign(tag, nextProps.tag);
      oriTag = clone(tag);
    }
    this.setState({ tag, oriTag });
  }
  submit(url, opts) {
    return this.form.submit(url, opts);
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const { tag } = this.state;
    AppForm.validate(this.validation, tag)
      .then((validations) => {
        this.props.onSubmit(validations, tag);
      });
  }
  handleCheckChanges() {
    if (this.props.onChange) {
      this.props.onChange(true);
    }
  }
  handleInputChange = (event, data) => {
    const { tag } = this.state;
    tag[data.name] = data.value;
    this.setState({ tag }, () => {
      this.handleCheckChanges();
    });
  }
  render() {
    const { t } = this.props;
    const { tag } = this.state;
    return (
      <AppForm
        onSubmit={this.handleSubmit}
        error={this.state.errMessages.length > 0}
        ref={(ref) => { this.form = ref; }}
      >
        <Grid columns="equal" stackable doubling>
          <Grid.Row>
            <Grid.Column>
              <AppForm.Input
                label={t('Name', { ns: TRANSLATION_FILES.translation })}
                name="name"
                value={tag.name}
                onChange={this.handleInputChange}
                ref={this.validation.name}
                validation={[required]}
              />
              <Form.TextArea
                label={t('Description', { ns: TRANSLATION_FILES.screens })}
                name="description"
                value={tag.description}
                onChange={this.handleInputChange}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </AppForm>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(TagForm);




// WEBPACK FOOTER //
// ./src/containers/Tags/Form.jsx